<template>
  <div class="pt-4">
    <h1>{{ title }}</h1>
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'Info',
  props: {
    title: String,
    text: String,
  },
};
</script>

<style scoped>

</style>